const REGION_WORDS: any = {
  "United States": "Housing",
  Canada: "Housing",
};

export default REGION_WORDS;
